import type {
  ReviewsResponseMapper,
} from '@/scopes/products/user-reviews/infrastructure/api/reviews/reviewsResponseMapper'
import type { Reviews } from '@/scopes/products/user-reviews/types'
import defaultFetch from 'isomorphic-unfetch'

import {
  createQueryStringSerializer,
  type QueryStringSerializer,
} from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'
import {
  createReviewsResponseMapper,
} from '@/scopes/products/user-reviews/infrastructure/api/reviews/reviewsResponseMapper'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
  queryStringSerializer: QueryStringSerializer
  reviewsResponseMapper: ReviewsResponseMapper
}

export interface GetUserReviewsParameters {
  contextItemId: string
  sorting: string
  showOnlyInWebsiteLanguage: boolean
  partyCompositionGroupId: string
  offset: number
  limit: number
}

export function createReviewsAPIClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
    queryStringSerializer = createQueryStringSerializer(),
    reviewsResponseMapper = createReviewsResponseMapper(),
  } = dependencies as Dependencies

  async function getUserReviews({
    contextItemId,
    sorting,
    showOnlyInWebsiteLanguage,
    partyCompositionGroupId,
    offset,
    limit,
  }: GetUserReviewsParameters): Promise<Reviews> {
    const queryString = queryStringSerializer.serialize({
      contextItemId,
      sorting,
      showOnlyInWebsiteLanguage,
      offset,
      travelertypes: partyCompositionGroupId,
      limit,
    })

    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/UserReviewsApi/GetUserReviews?${queryString}`)

    const data = await response.json()

    return reviewsResponseMapper.map(data)
  }

  return { getUserReviews }
}
